import { IconButton, Paper } from "@mui/material";
import React from "react";
import { MdOutlineArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import MyButton from "../../Components/global/MyButton";

export default function PageName({
  title,
  onClick,
  search = false,
  searchValue,
  searchOnChange,
  button,
  buttonTitle = "View on Map",
  buttonOnClick,
}) {
  const navigate = useNavigate();

  return (
    <Paper className="p-2" sx={{ borderRadius: 2 }}>
      <div className="flex items-center justify-between w-full">
        {/* Page name */}
        <div className="font-medium uppercase text-green-700 text-xl bg-white flex items-center gap-4">
          <IconButton onClick={onClick ? onClick : () => navigate(-1)}>
            <MdOutlineArrowBack className="text-green-700 " size={25} />
          </IconButton>
          <div className="mb-1 text-nowrap">{title}</div>
        </div>

        {/* Search bar */}
        {search && (
          <div className="justify-end flex items-center">
            <input
              className="rounded-full rounded-r-none p-2 px-2 w-72 border-2 border-r-0 border-gray-300 hover:outline-4 duration-200 focus:outline-green-600 font-normal"
              placeholder="Search here..."
              value={searchValue}
              onChange={searchOnChange}
            />

            <div className="cursor-pointer p-3 bg-green-600 rounded-r-full px-4">
              <IoIosSearch size={20} className="text-white" />
            </div>
          </div>
        )}

        {/* Button Section */}
        {button && (
          <div className="justify-end flex items-center">
            <MyButton onClick={buttonOnClick}>{buttonTitle}</MyButton>
          </div>
        )}
      </div>
    </Paper>
  );
}
